// App-side delegate for `@heidi/templates/data` (D2, ARCFE-1016).
// See the sibling delegate: the auth + user gate is composed here and crosses
// as one boolean (cohort-C).
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import {
  GET_ORGANIZATION_TEMPLATES,
  type SearchTemplatesResponse,
} from '@heidi/templates/contracts';
import {
  type OrganizationTemplatesQueryInput,
  useQueryOrganizationTemplates as useQueryOrganizationTemplatesCore,
} from '@heidi/templates/data';
import { useQueryUser } from './useQueryUser';

export { GET_ORGANIZATION_TEMPLATES };
export type { OrganizationTemplatesQueryInput };

export function useQueryOrganizationTemplates<T = SearchTemplatesResponse>(
  input?: OrganizationTemplatesQueryInput,
  select?: (data: SearchTemplatesResponse) => T
) {
  const { isAuthenticated } = useIsAuthenticated();
  const { data: userData } = useQueryUser();

  return useQueryOrganizationTemplatesCore<T>(
    input,
    select,
    Boolean(isAuthenticated && userData)
  );
}
